/*
 *
 * GroupsInfoPopup
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 09-May-2025
*/

import { connect } from 'react-redux'
import GroupsInfoPopup from './GroupsInfoPopup'

const mapDispatchToProps = dispatch => ({
})

const mapStateToProps = () => ({

})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(GroupsInfoPopup)
